<!--
 * @Author: your name
 * @Date: 2020-08-12 10:16:30
 * @LastEditTime: 2021-12-10 10:56:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath     : \vue-gaokao-ebook\src\views\login\login.vue
-->
<template>
  <div class="login">
    <div class="layer">
      <div class="form">
        <div class="bar">
          <div class="close el-icon-close" @click="closeLogin"></div>
        </div>

        <div class="user" v-if="tab==0">
          <div class="title">用户名登录</div>
          <div class="content">
            <el-form
              :model="ruleForm"
              status-icon
              :rules="rules"
              ref="ruleForm"
              label-width="0px"
              class="demo-ruleForm"
            >
              <el-form-item prop="username">
                <el-input  @keyup.enter.native="submitForm('ruleForm')" v-model="ruleForm.username" maxlength="20" placeholder="请输入用户名"></el-input>
              </el-form-item>
              <el-form-item prop="pass">
                <el-input
                  type="password"
                  maxlength="20"
                  v-model="ruleForm.pass"
                  placeholder="请输入密码"
                  autocomplete="off"
                  @keyup.enter.native="submitForm('ruleForm')"
                  show-password
                ></el-input>
              </el-form-item>
              <el-form-item label>
                <el-button
                  type="primary"
                  :style="{'background-color': isDisabled ? '#585858' : '#5c307d','cursor':isDisabled ? '':'pointer'}"
                  @click="submitForm('ruleForm')"
                  :disabled="isDisabled"
                >登录</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="mode">
            <div class="left" @click="clickMode(1)">手机号登录</div>
            <div class="center" @click="clickMode(3)">注册</div>
            <div class="right" @click.prevent="setPassword" >忘记密码？</div>
          </div>
          <div class="bottom">
            <div class="wxbtn">
              <img src="@/assets/images/login/qr.png" @click="clickMode(2)" alt />
            </div>
          </div>
        </div>

        <div class="phone" v-if="tab==1">
          <div class="title">手机号登录</div>
          <div class="content">
            <el-form
              :model="ruleForm"
              status-icon
              :rules="rules"
              ref="ruleForm"
              label-width="0px"
              class="demo-ruleForm"
            >
              <el-form-item prop="phone">
                <el-input
                  v-model="ruleForm.phone"
                  placeholder="请输入11位手机号码"
                  @keyup.enter.native="submitForm('ruleForm')"
                  maxlength="11"
                ></el-input>
              </el-form-item>
              <el-form-item prop="very_code" id="verify">
                <el-input
                  id="verify_text"
                  v-model="ruleForm.very_code"
                  placeholder="请输入验证码"
                  onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                  oninput="if(value.length>6)value=value.slice(0,6)"
                  autocomplete="off"
                  @keyup.enter.native="submitForm('ruleForm')"
                ></el-input>
                <div
                  class="verify_code"
                  :style="{'color': isSend ? '#585858' : '#5c307d','cursor':isSend ? '':'pointer'}"
                  @click="getCode"
                >{{timing}}</div>
              </el-form-item>

              <el-button
                type="primary"
                :style="{'background-color': isDisabled ? '#585858' : '#5c307d','cursor':isDisabled ? '':'pointer'}"
                @click="phoneSubmitForm('ruleForm')"
                :disabled="isDisabled"
              >登录</el-button>
            </el-form>
          </div>
          <div class="mode">
            <div class="left" @click="clickMode(0)">用户名登录</div>
            <div class="center" @click="clickMode(3)">注册</div>
            <div class="right" @click.prevent="setPassword">忘记密码？</div>
          </div>
          <div class="bottom">
            <div class="wxbtn">
              <img src="@/assets/images/login/qr.png" @click="clickMode(2)" alt />
            </div>
          </div>
        </div>

        <div class="wx" v-if="tab==2">
          <div class="title">微信登录</div>
          <div class="content">
            <wxlogin
              class="ifam"
              :appid= "appid"
              :scope="'snsapi_login'"
              theme="white"
              :state="state"
              :redirect_uri="encodeURIComponent(redirect_uri)"
              href="data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsKIGRpc3BsYXk6IG5vbmU7Cn0KLmltcG93ZXJCb3ggewogbGluZS1oZWlnaHQ6MTsKfQouaW1wb3dlckJveCAucXJjb2RlIHsKIGJvcmRlcjogbm9uZTsKIHdpZHRoOiA2MyU7CiBtYXJnaW4tdG9wOjA7Cn0KLmltcG93ZXJCb3ggLnN0YXR1cyBwewogZm9udC1zaXplOjEycHg7Cn0KI3d4X2RlZmF1bHRfdGlwIHA6bGFzdC1jaGlsZHsKIGRpc3BsYXk6bm9uZTsKfQouaW1wb3dlckJveCAuaW5mb3sKIGhlaWdodDozMHB4Owogd2lkdGg6IDE0OHB4OwogbWFyZ2luOiAtMTFweCBhdXRvICFpbXBvcnRhbnQ7Cn0KLmltcG93ZXJCb3ggLnN0YXR1c3sKIHBhZGRpbmc6MDsKfQouaW1wb3dlckJveCAuc3RhdHVzewogY29sb3I6IzYyNmI4MDsKfQoud3JwX2NvZGV7CiBoZWlnaHQ6NjElOwp9Ci5pbXBvd2VyQm94IC5pbmZvIC5zdGF0dXN7CmhlaWdodDozMHB4Owpmb250LXNpemU6MTJweDsKfQouaW1wb3dlckJveCAuc3RhdHVzIC5zdGF0dXNfdHh0IHB7CiBkaXNwbGF5OiBub25lOwp9Ci5pbXBvd2VyQm94IC5pY29uMzhfbXNnLnN1Y2N7CiAgYmFja2dyb3VuZC1zaXplOiAyMHB4OwogIGJhY2tncm91bmQtcG9zaXRpb246IDAgLTIxcHg7Cn0KLmltcG93ZXJCb3ggLmljb24zOF9tc2d7CiB3aWR0aDoyNXB4OwogaGVpZ2h0OjI1cHg7Cn0KLmltcG93ZXJCb3ggLmljb24zOF9tc2cud2FybnsKICBiYWNrZ3JvdW5kLXNpemU6IDIwcHg7CiAgYmFja2dyb3VuZC1wb3NpdGlvbjogMCAtNDRweDsKfQ=="
            ></wxlogin>
          </div>
          <div class="bottom">
            <div class="mode">
              <div class="left" @click="clickMode(0)">密码登录</div>
              <div class="center" @click="clickMode(3)">注册</div>
              <div class="right" @click="clickMode(1)">手机号登录</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <input type="hidden" @keydown.enter="alert(111)"> -->

    <!-- 登陆新增 -->
      <el-dialog
        title="完善信息"
        :visible.sync="centerDialogVisible"
        center
        custom-class="dialog_visible"
        :append-to-body="true"
        @close="closeDialog">
        <el-form
          :model="ruleFormPhone"
          status-icon
          :rules="rulesPhone"
          ref="ruleFormPhone"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div class="form_user">
            <div class="tips">账号和密码默认一致,可以去账号设置中修改密码</div>
            <el-form-item label="账号" prop="username">
              <el-tooltip class="item" effect="dark" content="账号长度为6-20,不能为纯数字,可使用字母、数字、_" placement="top">
                <el-input v-model="ruleFormPhone.username" maxlength="20" placeholder="密码和账号默认一致"></el-input>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="选择省份" prop="province">
              <el-cascader
                v-model="addressArr"
                :options="address"
                @change="getTypeByProv">
              </el-cascader>
            </el-form-item>
            <el-form-item label prop="soa" v-if="gkType == 0">
              <div class="csoa">
                <div class="tip">请选择文/理科</div>
                <div>
                  <el-radio-group v-model="ruleFormPhone.soa">
                    <el-radio label="理科"></el-radio>
                    <el-radio label="文科"></el-radio>
                  </el-radio-group>
                </div>
              </div>
            </el-form-item>
            <el-form-item label prop="checkList" v-if="gkType == 1">
              <div class="csoa">
                <div class="tip">请选择学科</div>
                <div>
                  <el-checkbox-group v-model="ruleFormPhone.checkList" :max="6">
                    <el-checkbox label="语文" disabled></el-checkbox>
                    <el-checkbox label="数学" disabled></el-checkbox>
                    <el-checkbox label="英语" disabled></el-checkbox>
                    <el-checkbox label="物理"></el-checkbox>
                    <el-checkbox label="化学"></el-checkbox>
                    <el-checkbox label="生物"></el-checkbox>
                    <el-checkbox label="政治"></el-checkbox>
                    <el-checkbox label="历史"></el-checkbox>
                    <el-checkbox label="地理"></el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </el-form-item>
            <el-form-item label prop="agree">
              <el-checkbox v-model="ruleFormPhone.agree">同意</el-checkbox>
              <a target="_blank" href="#/register/argeement">用户协议</a>
            </el-form-item>
          </div>
          <el-form-item label>
            <!-- :style="{'background-color': isDisabled ? '#585858' : '#5c307d','cursor':isDisabled ? '':'pointer'}" :disabled="isDisabled"  -->
            <el-button type="primary" @click="submitPhoneForm('ruleFormPhone')">保存</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
  </div>
</template>

<script>
import high_school_subjcet from "@/assets/js/subject-data.js";
import wxlogin from "@/components/wx-login/wx-login.vue";
import address from '@/assets/js/address'
export default {
  name: "login",
  components: {
    wxlogin,
  },
  data() {
    //校验邮箱
    let re = /^\w+@[a-z0-9]+\.[a-z]{2,4}$/;
    //不能包含汉字
    let valid_no_chinese = /^[^\u4e00-\u9fa5]+$/g;
    //输入的用户名只能用英文，数字和'_'
    let valid_un = /^\w+$/g;
    //纯数字
    let valid_num = /^\d+$/g;
    //空格
    let space = /\s/;
    var un_is_nan = (rule, value, callback) => {
      // if (value.match(valid_num)) {
      //   callback(new Error("用户名不能为纯数字"));
      // } else 
      if (!value.match(valid_no_chinese)) {
        callback(new Error("用户名不能输入中文"));
      } else if(!value.match(valid_un)){
        callback(new Error("用户名只能输入为字母,数字,下划线_"));
      }else {
        callback();
      }
    };

    var pass = (rule, value, callback) => {
      if(value.match(space)){
        callback(new Error("密码不能输入空格!"));
      }else{
        callback();
      }
    }
    var very_if_code = (rule, value, callback) => {
      let code_str = window.localStorage.getItem("login_code");
      let code_info = JSON.parse(code_str);
      if (value != code_info.very_code) {
        callback(new Error("验证码错误"));
      } else {
        let time_end = code_info.time_end;
        let time_now = new Date().getTime();
        if (time_now > time_end) {
          callback(new Error("验证码超时,请重新发送"));
        } else {
          callback();
        }
      }
    };
    let phone_valid = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
    var phone_is_nan = (rule, value, callback) => {
      
      if(!value.match(phone_valid)){
        callback(new Error("不是一个手机号!"));
      }else{
        callback();
      }
    };
    var choose_subject = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("请至少选择六科"));
      } else {
        callback();
      }
    };
    var agree_is = (rule, value, callback) => {
      if (!this.ruleFormPhone.agree) {
        callback(new Error("请同意用户协议"));
      } else {
        callback();
      }
    };
    return {
      address,
      addressArr: [],
      gkType: 0,
      centerDialogVisible: false,
      num: 0,
      ruleFormPhone: {
        //表单数据
        username: "", // 用户名
        pass: "", // 密码
        confirm_pass: "", // 确认密码
        province: "", // 省份
        checkList: ["语文", "数学", "英语"],
        soa: "",
        school: "", // 设置学校
        name: "", // 
        agree: true,
        phone : '',
        very_code : '',
      },
      rulesPhone: {
        username: [
          { required: true, message: "请设置账号", trigger: "blur" },
          { min: 6, max: 20, message: "账号长度为6-20", trigger: "blur" },
          { validator: un_is_nan, trigger: "blur" },
        ],
        province: [
          { required: true, message: "请选择省份", trigger: "change" },
        ],
        checkList: [{ validator: choose_subject, trigger: "change" }],
        soa: [{ required: true, message: "请选择学科", trigger: "change" }],
        agree: [
          { required: true, message: "请同意用户协议", trigger: "change" },
          { validator: agree_is, trigger: "change" },
        ]
      },
      tab: 0,
      //验证码相关
      timing: "获取验证码",
      generate_verify_code: "",
      isSend: false,
      countdown: 60,
      appid : this.$config.wxInfo.appid,
      redirect_uri : this.$config.wxInfo.redirect_uri,
      ruleForm: {
        //表单数据
        username: "",
        pass: "",
        phone: "",
        very_code: "",
      },
      //校验规则
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { min: 6, max: 20, message: "用户名长度为6-20", trigger: "blur" },
          { validator: un_is_nan, trigger: "blur" },
          // {validator : pass , trigger : "blur"}
        ],
        pass: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 20, message: "密码长度为6-20", trigger: "blur" },
          {validator : pass , trigger : "blur"}
        ],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { min: 11, max: 11, message: "手机号码长度11", trigger: "blur" },
          { validator: phone_is_nan, trigger: "blur" },
        ],
        very_code: [
          { required: true, message: "请输验证码", trigger: "blur" },
          { min: 6, message: "验证码长度为6", trigger: "blur" },
          { validator: very_if_code, trigger: "blur" },
        ],
      },
      //禁用
      isDisabled: false
    };
  },
  methods: {
    getSubjects(){
      let subject_ids_str ='' ;
      let SS = this.ruleFormPhone.checkList;
      let HSS = high_school_subjcet;
      let SISA = [];
      if(this.ruleFormPhone.gkType == 0){
        if(this.ruleFormPhone.soa == 0){
          this.ruleFormPhone.checkList = ['语文','数学','英语','物理','化学','生物'];
        }else{
          this.ruleFormPhone.checkList = ['语文','数学','英语','历史','政治','地理'];
        }
      }
      //i为键值
      for( var i in HSS){
        //j为数组索引
          for( var j in SS){
              if(HSS[i] == SS[j]){
                SISA.push(i);
              }
          }
      }
      subject_ids_str = SISA.toString();
      SISA = [];
      return subject_ids_str;
    },
    submitPhoneForm(ruleFormPhone) {
      this.$refs[ruleFormPhone].validate((valid) => {
        if(valid) {
          // 手机号注册
          let subject_ids_str = this.getSubjects();
          let regInfo = {
            countyId: this.addressArr[2] || null,
            cityId: this.addressArr[1] || null,//城市id
            provinceId : this.ruleFormPhone.province,//县城id
            gradeId: 6,
            termId: 3,
            schoolId: 280889,
            username:  this.ruleFormPhone.username,
            mobile: this.ruleForm.phone,
            name: this.ruleForm.phone,
            type: 0,
            subject_ids: subject_ids_str,
            'verify-code': this.ruleForm.very_code,
          };
          this.$HTTP
            .executePost(this.$APIS.USER_REGISTER_PHONE_VERIFY_CODE, regInfo, this)
            .then((response) => {
              if (response.code == 0) {
                this.$message.success("注册成功!");
                let userinfo = response.data;
                var userinfo_json = JSON.stringify(userinfo);
                window.localStorage.setItem("userinfo", userinfo_json);
                this.$store.commit('changeIsShowLogin',false);
                this.$store.commit('updateUserInfo',userinfo_json);
                this.$root.eventHub.$emit("show-login-succes", true);
                window.localStorage.setItem("isLogin", true);
                if(this.$route.path == '/tfedu_common/register') {
                  this.$router.push({
                    path: '/tfedu_common/home',
                    query: {
                      t: new Date().getTime()
                    }
                  });
                } else {
                  this.$router.go(0)
                }
              } else {
                this.isDisabled = false;
                this.$message.error(response.msg);
              }
            });
        }
      })
      
    },
    getTypeByProv() {
      this.ruleFormPhone.province = this.addressArr[0]
      this.$HTTP
        .executeGet(this.$APIS.GET_TYPE_BY_PROVINCE + this.ruleFormPhone.province, this)
        .then((response) => {
          this.gkType = response.gkType;
        });
    },
    closeDialog() {
      this.$message.error('基本信息设置失败, 请重新注册')
      this.centerDialogVisible = false
    },
    setPassword() {
      this.$router.push({
        path: '/reterieve_password',
        query: {
          t: new Date().getTime()
        }
      })
    },
    // 手机号注册
    phoneSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if(valid) {
          this.isDisabled = true;
          this.phone_login();
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isDisabled = true;
          if (this.tab == 0) {
            this.user_login();
          } else {
            this.phone_login();
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    user_login() {
      let data = {
        username: this.ruleForm.username,
        password: this.ruleForm.pass,
        // macAddress: this.$cookies.get('MachineId') || null
      };
      this.$HTTP
        .executePost(this.$APIS.USER_LOGIN, data, this)
        .then((response) => {
          if (response.code == 0) {
            let userinfo = response.data;
            userinfo.password = this.password;
            var userinfo_json = JSON.stringify(userinfo);
            window.localStorage.setItem("userinfo", userinfo_json);
            window.localStorage.setItem("isLogin", true);
            this.$store.commit('changeIsShowLogin',false);
            this.$store.commit('updateUserInfo',userinfo_json);
            this.$root.eventHub.$emit("show-login-succes", true);
            if(this.$route.path == '/tfedu_common/register') {
              this.$root.eventHub.$emit('changePath', 'home')
              this.$router.push({
                path: '/tfedu_common/home',
                query: {
                  t: new Date().getTime()
                }
              });
            } else {
              this.$router.go(0)
            }
          } else {
            this.isDisabled = false;
            this.$message.error(response.msg);
            return false
          }
        });
    },
    phone_login() {
      let data = {
        mobile: this.ruleForm.phone,
        "verify-code": this.ruleForm.very_code,
        // macAddress: this.$cookies.get('MachineId') || null
      };
      this.$HTTP
        .executePost(this.$APIS.USER_LOGIN_BY_VERIFY_CODE, data, this)
        .then((response) => {
          if (response.code == 0) {
            let userinfo = response.data;
            userinfo.password = this.password;
            var userinfo_json = JSON.stringify(userinfo);
            window.localStorage.setItem("userinfo", userinfo_json);
            this.$store.commit('changeIsShowLogin',false);
            this.$store.commit('updateUserInfo',userinfo_json);
            this.$root.eventHub.$emit("show-login-succes", true);
            window.localStorage.setItem("isLogin", true);
            if(this.$route.path == '/tfedu_common/register') {
              this.$router.push({
                path: '/tfedu_common/home',
                query: {
                  t: new Date().getTime()
                }
              });
            } else {
              this.$router.go(0)
            }
          } else if (response.code == 1) {
            // this.$message.error(response.msg);
            this.$message.error('手机号未注册！请先注册。')
            this.isDisabled = false
            this.changeUserName(`syb${this.ruleForm.phone}`)
            // this.centerDialogVisible = true
            clearInterval(this.timer)
            this.timing = "获取验证码";
            this.countdown = 60;
          } else {
            this.isDisabled = false
            this.$message.error(response.msg);
            return false
          }
        });
    },
    changeUserName(username) {
      this.$HTTP
        .executeGet(this.$APIS.USERNAME_EXISTS + username, this)
        .then((res) => {
          if (!res.valid) {
            this.num++
            this.changeUserName(`${username}${this.num}`)
          } else {
            this.ruleFormPhone.username = `${username}`
            return false
          }
        });
    },
    clickMode(val) {
      if(val == 3) {
        this.$router.push('/tfedu_common/register')
        this.$store.commit('changeIsShowLogin',false);
        return
      } else {
        this.tab = val;
        this.resetForm("ruleForm");
      }
    },
    getCode() {
      //校验手机号
      if (this.ruleForm.phone.length != 11) {
        this.$message.error("这不是一个手机号码");
        return;
      }

      // if (this.countdown != 60) return;
      if (!this.isSend) {
        this.isSend = true;
        //生成一个6位数的验证码
        this.generate_verify_code = Math.random().toString().substring(2, 8);
        //发送请求
        let data = {
          mobile: this.ruleForm.phone,
          "verify-code": this.generate_verify_code,
        };
        this.$HTTP
          .executePost(this.$APIS.USER_LOGIN_CODE, data, this)
          .then((response) => {
            if (response.msg == "Success!") {
              //验证码有效期为分钟,存到store中,设置有效期
              this.$message.success("请求验证码成功!");
              let code = {
                very_code: this.generate_verify_code,
                time_end: new Date().getTime() + 10 * 60 * 1000,
              };
              window.localStorage.setItem("login_code", JSON.stringify(code));
              if (!this.timer) {
                this.timer = setInterval(() => {
                  if (this.countdown >= 0 && this.countdown <= 60) {
                    this.countdown--;
                    if (this.countdown >= 0) {
                      this.timing = this.countdown + "s";
                    } else {
                      clearInterval(this.timer);
                      this.timing = "获取验证码";
                      this.countdown = 60;
                      this.isSend = false;
                    }
                  }
                }, 1000);
              }
            } else {
              this.$message.error(response.msg);
              this.isSend = false;
            }
          });
      }
    },
    closeLogin() {
      //this.$root.eventHub.$emit("show-login", false);
      this.$store.commit("changeIsShowLogin", false);
    },
  }
};
</script>

<style lang="stylus" scoped>
.tips {
  font-size: 16px;
  color: #585858;
  line-height: 30px;
  margin-left: 100px;
}
.login {
  width: 1920px;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 20;

  .layer {
    width: 420px;
    height: 455px;
    z-index: 1000;
    position: absolute;
    margin-top: 250px;
    margin-left: 750px;

    .form {
      width: 420px;
      height: 455px;
      background-color: #ffffff;
      position: absolute;
      border-radius: 10px;

      .bar {
        position: relative;
        float: left;
        width: 420px;
        height: 40px;

        .close {
          width: 30px;
          height: 30px;
          font-size: 30px;
          cursor: pointer;
          color: #585858;
          position: relative;
          float: right;
          padding-top: 10px;
          margin-right: 10px;
        }
      }

      .user {
        width: 420px;
        height: 415px;
        position: relative;
        float: left;

        .title {
          font-size: 28px;
          height: 50px;
          width: 420px;
          text-align: left;
          text-indent: 50px;
          color: #474747;
          position: relative;
          line-height: 50px;
          float: left;
        }

        .content {
          width: 420px;
          height: 265px;
          position: relative;
          float: left;

          >>> .el-form-item {
            margin-left: 50px;
            margin-top: 30px;

            .el-form-item__content {
              .el-input {
                width: 337px;
                height: 48px;
                float: left;

                input {
                  background-color: #f7f7f7;
                  border-radius: 50px;
                  height: 48px;
                  font-size: 16px;
                  color: #585858;
                  float: left;
                }

                .el-icon-circle-check {
                  color: green;
                }
              }

              .getcode {
                position: relative;
                float: left;
                padding-left: 10px;
                padding-top: 2px;
                font-size: 18px;
                color: #5c307d;
                cursor: pointer;
              }
            }
          }

          >>> .el-button {
            width: 337px;
            height: 50px;
            text-align: center;
            border-radius: 50px;
            font-size: 20px;
            color: #ffffff;
            margin-top: 0px;
            margin-left: -30px;
          }
        }

        .mode {
          width: 420px;
          height: 40px;
          position: relative;
          float: left;

          .left {
            height: 40px;
            position: relative;
            float: left;
            text-align: center;
            font-size: 16px;
            color: #626b80;
            margin-left: 50px;
            cursor: pointer;
          }

          .center {
            float: left;
            margin-left: 75px;
            cursor: pointer;
            font-size: 16px;
            color: #626b80;
          }

          .right {
            height: 40px;
            position: relative;
            text-align: center;
            float: right;
            font-size: 16px;
            color: #626b80;
            margin-right: 30px;
            cursor: pointer;
          }
        }

        .bottom {
          width: 420px;
          height: 60px;
          position: relative;
          float: left;

          .wxbtn {
            height: 60px;
            width: 60px;
            position: relative;
            float: right;
            cursor: pointer;

            img {
              height: 60px;
              width: 60px;
            }
          }
        }
      }

      .phone {
        width: 420px;
        height: 415px;
        position: relative;
        float: left;

        .title {
          font-size: 28px;
          height: 50px;
          width: 420px;
          text-align: left;
          text-indent: 50px;
          color: #474747;
          position: relative;
          line-height: 50px;
          float: left;
        }

        .content {
          width: 420px;
          height: 265px;
          position: relative;
          float: left;

          >>> .el-form-item {
            margin-left: 50px;
            width: 337px;
            height: 48px;
            position: relative;
            margin-top: 30px;

            .el-form-item__content {
              width: 337px;
              height: 48px;
              position: relative;
              float: left;

              .el-input {
                width: 337px;
                height: 48px;
                float: left;
                position: relative;

                input {
                  background-color: #f7f7f7;
                  border-radius: 50px;
                  height: 48px;
                  font-size: 16px;
                  color: #585858;
                  float: left;
                  position: relative;
                }

                .el-icon-circle-check {
                  color: green;
                }
              }
            }
          }

          >>> #verify {
            margin-left: 50px;
            width: 337px;
            height: 48px;
            position: relative;
            float: left;
            margin-top: 8px;

            .el-input {
              width: 217px;
              height: 48px;
              float: left;
              position: relative;

              input {
                background-color: #f7f7f7;
                border-radius: 50px;
                height: 48px;
                font-size: 16px;
                width: 217px;
                border-radius: 50px 0px 0px 50px;
                float: left;
              }

              .el-icon-circle-check {
                color: green;
              }
            }

            .verify_code {
              position: relative;
              background-color: #f7f7f7;
              width: 120px;
              border-radius: 0px 50px 50px 0px;
              height: 48px;
              line-height: 45px;
              font-size: 16px;
              border: 1px #dcdfe6 solid;
              border-left: none;
              color: #5c307d;
              float: left;
            }
          }

          >>> .el-button {
            position: relative;
            float: left;
            width: 337px;
            height: 50px;
            text-align: center;
            background-color: #5c307d;
            border-radius: 50px;
            font-size: 20px;
            color: #ffffff;
            margin-top: 8px;
            margin-left: 51.5px;
          }
        }

        .mode {
          width: 420px;
          height: 40px;
          position: relative;
          float: left;

          .left {
            height: 40px;
            position: relative;
            float: left;
            text-align: center;
            font-size: 16px;
            color: #626b80;
            margin-left: 50px;
            cursor: pointer;
          }

          .center {
            float: left;
            margin-left: 85px;
            cursor: pointer;
            font-size: 16px;
            color: #626b80;
          }

          .right {
            height: 40px;
            position: relative;
            text-align: center;
            float: right;
            font-size: 16px;
            color: #626b80;
            margin-right: 30px;
            cursor: pointer;
          }
        }

        .bottom {
          width: 420px;
          height: 60px;
          position: relative;
          float: left;

          .wxbtn {
            height: 60px;
            width: 60px;
            position: relative;
            float: right;

            img {
              height: 60px;
              width: 60px;
            }
          }
        }
      }

      .wx {
        width: 420px;
        height: 415px;
        position: relative;
        float: left;

        .title {
          font-size: 28px;
          height: 50px;
          width: 420px;
          text-align: left;
          text-indent: 50px;
          color: #474747;
          position: relative;
          line-height: 50px;
          float: left;
        }

        .content {
          width: 420px;
          height: 265px;
          position: relative;
          float: left;
          .ifam {
            width: 100% !important;
          }
          
        }

        .bottom {
          width: 420px;
          height: 60px;
          position: relative;
          float: left;
          margin-top: 10px;

          .mode {
            width: 420px;
            height: 40px;
            position: relative;
            float: left;

            .left {
              height: 40px;
              position: relative;
              float: left;
              text-align: center;
              font-size: 16px;
              color: #626b80;
              margin-left: 50px;
              cursor: pointer;
            }
            .center {
              float: left;
              margin-left: 85px;
              cursor: pointer;
              font-size: 16px;
              color: #626b80;
            }

            .right {
              height: 40px;
              position: relative;
              text-align: center;
              float: right;
              font-size: 16px;
              color: #626b80;
              margin-right: 30px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>